// ////////////////////////////////////////////////////////////////////////////////////////////////
// BEWARE THAT THIS COMPONENT IS ALSO USED IN igbusiness/BmcBlock
// Make sure no to change any interface
// ////////////////////////////////////////////////////////////////////////////////////////////////

import React from 'react';
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';

@observer
class BlockActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    // TODO: important add IgBusiness permission, temp fix
    this.canEdit = props.blockStore.rootStore.authorizationStore
      ? props.blockStore.rootStore.authorizationStore.canEdit
      : true;

    this.handleAddButton = this.handleAddButton.bind(this);
  }

  render() {
    return <div style={{ flex: 1 }}>{this.canEdit && this.renderBtn()}</div>;
  }

  renderBtn() {
    // if (false && (this.props.blockStore.name === BMC_BLOCKS.REVENUE_STREAMS || this.props.blockStore.name === BMC_BLOCKS.COST_STRUCTURE)) {
    //     return (
    //         <Row>
    //             <Col sm={4} className="bmc-col-lane">
    //                 <button onClick={this.handleAddButton}
    //                         className="btn btn-default full-width margin-10Bottom">
    //
    //                     {this.props.intl.formatMessage({id: "add"})}
    //                 </button>
    //             </Col>
    //         </Row>
    //     );
    // } else {
    return (
      <button
        onClick={this.handleAddButton}
        className="btn btn-default full-width full-width margin-10Bottom"
      >
        {this.props.intl.formatMessage({ id: 'add' })}
      </button>
    );
    // }
  }

  @action
  handleAddButton(e) {
    this.props.blockStore.showBlockModal(true);
  }
}

export default injectIntl(BlockActions);
